
/* styles */
require("!!../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-4fbc2ebc\",\"scoped\":false,\"hasInlineConfig\":true}!sass-loader?sourceMap!../node_modules/vue-loader/lib/selector?type=styles&index=0!../node_modules/string-replace-loader/index.js??ref--2!./App.vue")

var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!../node_modules/string-replace-loader/index.js??ref--2!./App.vue"),
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-4fbc2ebc\"}!../node_modules/vue-loader/lib/selector?type=template&index=0!../node_modules/string-replace-loader/index.js??ref--2!./App.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./client/App.vue
// module id = 338
// module chunks = 143